import { generatePath } from 'react-router-dom'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { SubscriptionDetailDetailsKey } from 'api/Trading-Accounts/Types/SubscriptionDetailDetailsDto'
import { Link } from 'components/Link'
import { links } from 'utils/featureToggles'

import { SubscriptionTab } from './SubscriptionSlug'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const subscriptionColumns: GridColumn[] = [
  {
    title: 'Name',
    field: SubscriptionDetailDetailsKey.name,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem?.subscription?.name) {
        return <td />
      }

      return (
        <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
          <Link
            to={{
              pathname: generatePath(links.administrationSubscriptions.detailsUrl as string, {
                id: props.dataItem.subscription.id,
                slug: SubscriptionTab.MAIN,
              }),
            }}
          >
            {props.dataItem.subscription.name}
          </Link>
        </td>
      )
    },
    minResizableWidth: 120,
    width: 120,
    show: true,
    filter: 'text',
  },
  {
    title: 'Type',
    field: SubscriptionDetailDetailsKey.type,
    minResizableWidth: 120,
    width: 120,
    show: true,
    filter: 'text',
  },
  {
    title: 'Level',
    field: SubscriptionDetailDetailsKey.level,
    minResizableWidth: 120,
    width: 120,
    show: true,
    filter: 'text',
  },
  {
    title: 'Mapping Text',
    field: SubscriptionDetailDetailsKey.mappingText,
    minResizableWidth: 120,
    width: 120,
    show: true,
    filter: 'text',
  },
  {
    title: 'Amount',
    field: SubscriptionDetailDetailsKey.amount,
    minResizableWidth: 120,
    width: 120,
    show: true,
    filter: 'text',
    className: 'table-columns__number',
  },
  {
    title: 'Currency',
    field: SubscriptionDetailDetailsKey.currency,
    minResizableWidth: 120,
    width: 120,
    show: true,
    filter: 'text',
  },
  {
    title: 'Enabled',
    field: SubscriptionDetailDetailsKey.enabled,
    minResizableWidth: 120,
    width: 120,
    show: true,
    filter: 'text',
  },
  {
    title: 'Order',
    field: SubscriptionDetailDetailsKey.order,
    minResizableWidth: 120,
    width: 120,
    show: true,
    filter: 'text',
    className: 'table-columns__number',
  },
  {
    title: 'Tickmill Product',
    field: SubscriptionDetailDetailsKey.product,
    minResizableWidth: 120,
    width: 120,
    show: true,
    filter: 'text',
  },
]
